import { Component } from '@angular/core';

@Component({
  selector: 'ui-lightning-dropdown-item',
  templateUrl: './dropdown-item.component.html',
})
export class DropdownItemComponent {}
